import { Col } from 'antd';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const SearchBarContainerStyled = styled(Col)`
  padding: 0 16px;
  margin-bottom: 14px;
  min-width: 100%;
  max-width: 300px;
`;

export const ActionButtonContainerStyled = styled.div`
  width: 100%;
  @media screen and (max-width: ${breakpoints.sm}) {
    * {
      text-align: center;
    }
  }
`;
